'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ListTable = require('../ListTable/ListTable');

var _ListTable2 = _interopRequireDefault(_ListTable);

var _P = require('../P/P');

var _P2 = _interopRequireDefault(_P);

var _Input = require('./components/Input.TableList');

var _Input2 = _interopRequireDefault(_Input);

var _Content = require('./components/Content.TableList');

var _Content2 = _interopRequireDefault(_Content);

var _More = require('./components/More.TableList');

var _More2 = _interopRequireDefault(_More);

var _Loader = require('./components/Loader.TableList');

var _Loader2 = _interopRequireDefault(_Loader);

var _LargeLoader = require('./components/LargeLoader.TableList');

var _LargeLoader2 = _interopRequireDefault(_LargeLoader);

var _NotFound = require('./components/NotFound.TableList');

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var TableList = function (_Component) {
  _inherits(TableList, _Component);

  function TableList() {
    _classCallCheck(this, TableList);

    return _possibleConstructorReturn(this, (TableList.__proto__ || Object.getPrototypeOf(TableList)).apply(this, arguments));
  }

  _createClass(TableList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          loading = _props.loading,
          topleft = _props.topleft,
          topright = _props.topright,
          bottomleft = _props.bottomleft,
          bottomright = _props.bottomright,
          id = _props.id,
          search = _props.search,
          onSearch = _props.onSearch,
          page = _props.page,
          pages = _props.pages,
          onMore = _props.onMore,
          additionalProps = _props.additionalProps;
      return _react2.default.createElement('div', null, _react2.default.createElement(_Input2.default, {
        value: search,
        onChange: onSearch
      }), _react2.default.createElement(_Content2.default, null, !list.length && !loading && _react2.default.createElement(_NotFound2.default, null, _react2.default.createElement(_P2.default, {
        theme: 'darkGrey',
        align: 'center'
      }, 'No Results Found')), list.map(function (data, index) {
        return _react2.default.createElement(_ListTable2.default, _extends({
          key: id ? id(data) : null,
          topleft: topleft ? topleft(data) : null,
          topright: topright ? topright(data) : null,
          bottomleft: bottomleft ? bottomleft(data) : null,
          bottomright: bottomright ? bottomright(data) : null,
          noBorder: index + 1 === list.length
        }, additionalProps(data)));
      }), list.length === 0 && loading && _react2.default.createElement(_LargeLoader2.default, null), list.length > 0 && loading && _react2.default.createElement(_Loader2.default, null), list.length > 0 && !loading && page < pages && _react2.default.createElement(_More2.default, {
        onClick: onMore
      }, _react2.default.createElement(_P2.default, {
        theme: 'blue',
        align: 'center',
        weight: 'medium'
      }, 'Load More'))));
    }
  }]);

  return TableList;
}(_react.Component);

TableList.propTypes = {
  list: _propTypes2.default.array,
  topleft: _propTypes2.default.func,
  topright: _propTypes2.default.func,
  bottomleft: _propTypes2.default.func,
  bottomright: _propTypes2.default.func,
  id: _propTypes2.default.func,
  search: _propTypes2.default.string,
  onSearch: _propTypes2.default.func,
  page: _propTypes2.default.number,
  pages: _propTypes2.default.number,
  onMore: _propTypes2.default.func,
  additionalProps: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};
TableList.defaultProps = {
  additionalProps: function additionalProps() {
    return {};
  }
};
exports.default = TableList;